import { postJson } from '../httpClient';

/**
 * Cookie consent audit trail.
 *
 * Fire-and-forget from the caller's point of view: the visitor's choice is
 * already in their cookie by the time this runs, so a failure here loses the
 * record, never the decision.
 */
export const consentAPI = {
  log: params => postJson('/api/consent/log', params),
};
